// src/helpers/textUtils.js

/**
 * Strips HTML tags from a string and then truncates the resulting plain text.
 * @param {string} htmlString The string possibly containing HTML.
 * @param {number} maxLength The maximum length for the truncated text.
 * @returns {string} The stripped and truncated plain text.
 */
export const stripHtmlAndTruncate = (htmlString, maxLength) => {
    // Create a temporary div element
    const tempDiv = document.createElement('div');
    // Set its innerHTML to the provided htmlString. The browser parses it.
    tempDiv.innerHTML = htmlString;
    // Get the plain text content
    let text = tempDiv.textContent || tempDiv.innerText || ''; // Fallback for older browsers

    if (text.length > maxLength) {
        text = text.substring(0, maxLength);
        // Optional: Try to avoid cutting mid-word by finding the last space
        const lastSpaceIndex = text.lastIndexOf(' ');
        if (lastSpaceIndex !== -1 && lastSpaceIndex > maxLength * 0.7) { // Only cut at space if not too far back
            text = text.substring(0, lastSpaceIndex);
        }
        text += '...'; // Add ellipsis
    }
    return text;
};